// extracted by mini-css-extract-plugin
export var askAiIcon = "_mp-9";
export var container = "_mp-0";
export var groupSeparator = "_mp-a";
export var highlight = "_mp-4";
export var resultIcon = "_mp-5";
export var resultItem = "_mp-7";
export var resultSubtitle = "_mp-3";
export var resultTitle = "_mp-2";
export var resultsList = "_mp-1";
export var searchGroup = "_mp-6";
export var selected = "_mp-8";